import { useNavigate } from "react-router-dom"
import { STATUS_MAP } from "../../../_metronic/helpers/StatusBackgroundColorHelpers"
import { useMemo } from "react"

const RenderShieldRow = ({ params, fileDetails }: any) => {
    const navigate = useNavigate()

    const companyIcon = useMemo(() => {
        const companyId = params?.assignedTo?.id
        const files = fileDetails?.find((fd: any) => fd.company_id === companyId)?.res

        if (!companyId || !files?.length) return STATUS_MAP.grey

        let latestEO: any = null
        const foundStatuses = new Set<string>()

        files.forEach((file: any) => {
            const { complianceName, status, fileExpirationDate } = file
            if (complianceName === 'E&O') {
                if (!latestEO || new Date(fileExpirationDate) > new Date(latestEO.fileExpirationDate)) {
                    latestEO = file
                }
            } else if (['red', 'orange', 'green'].includes(status)) {
                foundStatuses.add(status)
            }
        })

        if (latestEO?.status) foundStatuses.add(latestEO.status)

        if (foundStatuses.has('red')) return STATUS_MAP.red
        if (foundStatuses.has('orange')) return STATUS_MAP.orange
        if (foundStatuses.has('green')) return STATUS_MAP.green

        return STATUS_MAP.grey
    }, [params?.assignedTo?.id, fileDetails])

    if (params?.tab === 'received' || !params.assignedTo) return <>N/A</>

    const isGrey = companyIcon === STATUS_MAP.grey

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <button
                type='button'
                onClick={() =>
                    !isGrey &&
                    navigate('/vendorprofile', {
                        state: {
                            searchCompanyId: params.assignedTo.id,
                            companyIcon,
                            tab: 'Documents & Compliance',
                        },
                    })
                }
                style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: isGrey ? 'not-allowed' : 'pointer',
                }}
                aria-label='Documents & Compliance'
                disabled={isGrey}
            >
                <img
                    src={`/media/ATR/icons/${companyIcon}`}
                    alt='status icon'
                    style={{ width: 35, height: 35, display: 'flex', marginTop: '-10px' }}
                />
            </button>
        </div>
    )
}
export { RenderShieldRow }